import * as types from './mutations-types'
import EventBus from './eventBus'
import api from './api'
import dateFormatter from '../utils/dateFormatter'
import CsvExport from './csv-export'
import moment from 'moment-timezone'
import _ from 'lodash'
// import {arrondissement} from '../filters'
import * as demandeStatut from './../utils/demandeStatut'
import XLSX from '../../static/js/plugins/xlsx/xlsx.full.min'
import {backofficeUrl, photoUrl} from '../config'
import state from './state'

export default {
  //
  // Login
  //

  login ({commit, state}, {login, password, rememberMe}) {
    commit(types.LOADING, 'Connexion en cours...')
    api.login(login, password).then(function (res) {
      let user = res.data
      localStorage.setItem('TOKEN', user.token)
      localStorage.setItem('REMEMBER', rememberMe)
      let role = ''
      let id = ''
      let arrondissement_id = ''
      id = user.id
      arrondissement_id = user.arrondissement_id
      if (!res.data.actif) {
        return commit(types.LOGIN_ERROR, {
          text: 'Impossible de vous identifier (raison : cet utilisateur a été désactivé)',
          type: 'danger',
        })
      } else {
        api.getVilleOfCurrentUser(user.ville_id).then(function (res) {
          // la récupération de la ville de l'utilisateur
          let ville = res.data
          if (user.jwtAuthorities.filter(u => u.jwtRole === 'ADMIN').length > 0) {
            role = 'ADMIN'
          } else if (user.jwtAuthorities.filter(u => u.jwtRole === 'COLLECTIVITY_USER').length > 0) {
            role = 'COLLECTIVITY_USER'
          } else {
            role = 'USER'
          }
          // if (rememberMe) {
          //   localStorage.setItem('TOKEN', user.token)
          // }

          commit(types.LOGIN_SUCCESS, {ville, role, id, arrondissement_id})
        })
      }
    }, function (err) {
      console.log(err)
      if (err.response.status === 401 && err.response.data.error === 'User account is locked') {
        commit(types.LOGIN_ERROR, {
          text: `Impossible de vous identifier (raison : cet utilisateur a été désactivé)`,
          type: 'danger',
        })
      } else if ((err.response.status === 401 && err.response.data.error === 'Bad credentials') || err.response.status === 404) {
        commit(types.LOGIN_ERROR, {
          text: `Impossible de vous identifier (raison : Nom d'utilisateur ou mot de passe incorrect)`,
          type: 'danger',
        })
      } else {
        commit(types.LOGIN_ERROR, {
          text: `Impossible de vous identifier (raison : Inconnue)`,
          type: 'danger',
        })
      }

    })

  },
  loginWithToken ({commit, state}, {login}) {
    commit(types.LOADING, 'Connexion en cours...')
    api.getUserByLogin(login).then(function (res) {
      let user = res.data
      let role = ''
      let id = ''
      let arrondissement_id = ''
      id = user.id
      arrondissement_id = user.arrondissement_id
      if (!res.data.actif) {
        return commit(types.LOGIN_ERROR, {
          text: 'Impossible de vous identifier (raison : cet utilisateur a été désactivé)',
          type: 'danger',
        })
      } else {
        api.getVilleOfCurrentUser(user.ville_id).then(function (res) {
          // la récupération de la ville de l'utilisateur
          let ville = res.data
          if (user.jwtAuthorities.filter(u => u.jwtRole === 'ADMIN').length > 0) {
            role = 'ADMIN'
          } else if (user.jwtAuthorities.filter(u => u.jwtRole === 'COLLECTIVITY_USER').length > 0) {
            role = 'COLLECTIVITY_USER'
          } else {
            role = 'USER'
          }
          commit(types.LOGIN_SUCCESS, {ville, role, id, arrondissement_id})
        })
      }
    }, function (err) {
      console.log(err)
      if (err.response.status === 401 && err.response.data.error === 'User account is locked') {
        commit(types.LOGIN_ERROR, {
          text: `Impossible de vous identifier (raison : cet utilisateur a été désactivé)`,
          type: 'danger',
        })
      } else if ((err.response.status === 401 && err.response.data.error === 'Bad credentials') || err.response.status === 404) {
        commit(types.LOGIN_ERROR, {
          text: `Impossible de vous identifier (raison : Nom d'utilisateur ou mot de passe incorrect)`,
          type: 'danger',
        })
      } else if ((err.response.status === 401 && err.response.data.error.includes('JWT expired'))) {
        commit(types.LOGIN_ERROR, {
          text: `Impossible de vous identifier (raison : Session expirée)`,
          type: 'danger',
        })
      } else if ((err.response.status === 401 && err.response.data.error.includes('JWT expired'))) {
        commit(types.LOGIN_ERROR, {
          text: `Impossible de vous identifier (raison : Session expirée)`,
          type: 'danger',
        })
      } else {
        commit(types.LOGIN_ERROR, {
          text: `Impossible de vous identifier (raison : Inconnue)`,
          type: 'danger',
        })
      }
    })
  },
  resetPassword ({commit}, {password, confirmPassword, maitriseId}) {
    commit(types.LOADING, 'Nouveau mot de passe...')
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/
    if (password !== confirmPassword) {
      commit(types.PASSWORD_UPDATED_ERROR, {
        text: `Les mots de passe ne sont pas identiques`,
        type: 'danger',
      })
      return
    }
    if (!pattern.test(password)) {
      commit(types.PASSWORD_UPDATED_ERROR, {
        text: `Impossible de modifier votre mot de passe car celui-ci n'est pas au bon format. Il doit contenir 8 caractères minimun dont : majuscules, minuscules, au moins un chiffre et un caractére spécial (@$!%*?&)`,
        type: 'danger',
      })
      return
    }
    api.resetPasssword(maitriseId, password).then(function (res) {
      console.log(res)
      commit(types.PASSWORD_UPDATED_SUCCESS)
      window.location.href = backofficeUrl + '/login'
    }, function (err) {
      console.log(err)
      commit(types.PASSWORD_UPDATED_ERROR, {
        text: `Impossible de modifier votre mot de passe (${err})`,
        type: 'danger',
      })
    })
  },
  logout ({commit}) {
    commit(types.LOADING, 'Déconnexion en cours...')
    api.logout().then(function (res) {
      /*      localStorage.clear()
            state.login.loggedIn = false*/
      commit(types.LOGOUT_SUCCESS)
      //location.reload()
    }, function (err) {
      console.log(err)
    })
  },
  forgotPassword ({commit}, login) {
    commit(types.LOADING, 'Mot de passe perdu...')
    api.getEmail(login).then(function (res) {
      if (res.data) {
        var maitrise = res.data
        console.log('the maitrise => ', maitrise)
        if (maitrise.actif) {
          api.forgotPassword(maitrise.email, maitrise.id).then(function (res) {
            console.log('response mailgun => ', res)
            commit(types.FORGOT_PASSWORD_SUCCESS)
          }, function (err) {
            commit(types.LOGIN_ERROR, {
              text: `Compte existant et actif, mais une erreur est survenue (raison : ${JSON.stringify(err)})`,
              type: 'danger',
            })
          })
        } else {
          commit(types.LOGIN_ERROR, {
            text: `Compte désactivé`,
            type: 'danger',
          })
        }
      } else {

      }
    }, function (err) {
      console.error(err)
      commit(types.LOGIN_ERROR, {
        text: `Compte inconnu : renseignez votre login pour recevoir un email qui vous permettra de récupérer votre mot de passe`,
        type: 'danger',
      })
    })
  },

//
//TOURNEES
//

  closeTournee({ commit }, tournee) {
    console.log(tournee.id)
    commit(types.LOADING, `Clôture de la tournée du ${tournee.startedAt}`)
    api.closeTournee(tournee.id)
      .then(res => {
        commit(types.TOURNEE_CLOSED, res.data)
      })
      .catch(err => {
        const action = 'clôture'
        commit(types.TOURNEE_ERROR, { action, err })
      })
  },

  //
  // Maitrises
  //

  createMaitrise ({commit, state}, maitrise) {
    commit(types.LOADING, `Création du maîtrise ${maitrise.nom} ${maitrise.prenom}`)
    console.log('actions maitrise ==>', maitrise)
    const body = {
      'actif': true,
      'telephone': maitrise.telephone.trim(),
      'login': maitrise.login.trim(),
      'email': maitrise.email.trim(),
      'nom': maitrise.nom.trim(),
      'prenom': maitrise.prenom.trim(),
      'arrondissement_id': maitrise.arrondissement_id,
      'ville_id': state.currentVille.id,
      'password': maitrise.password
    }
    api.createMaitrise(body)
      .then((res) => {
        console.log(res)
        let createdMaitrise = res.data
        commit(types.MAITRISE_CREATED, createdMaitrise)
      }).catch(err => {
      const action = 'création'
      commit(types.MAITRISES_ERROR, {action, err})
    })
  },
  updateMaitrise ({commit}, maitrise) {
    commit(types.LOADING, `Mise à jour du maîtrise ${maitrise.nom} ${maitrise.prenom}`)
    const body = {
      'telephone': maitrise.telephone.trim(),
      'actif': maitrise.actif,
      'login': maitrise.login.trim(),
      'email': maitrise.email.trim(),
      'nom': maitrise.nom.trim(),
      'prenom': maitrise.prenom.trim(),
      'contacts': maitrise.contacts,
      'arrondissement_id': maitrise.arrondissement_id
    }
    console.log('maitrise body sent ========', body)
    api.updateMaitrise(body, maitrise.id)
      .then((res) => {
        console.log(res)
        let updatedMaitrise = res.data
        commit(types.MAITRISE_UPDATED, updatedMaitrise)
      }).catch(err => {
      const action = 'modification'
      commit(types.MAITRISES_ERROR, {action, err})
    })
  },
  deactivateMaitrise ({commit}, maitrise) {
    commit(types.LOADING, `Désactivation du maîtrise ${maitrise.nom} ${maitrise.prenom}`)
    api.deactivateMaitrise(maitrise.id)
      .then((res) => {
        console.log('deactivation res ===>', res.data)
        let updatedMaitrise = res.data
        commit(types.MAITRISE_DEACTIVATED, updatedMaitrise)
      }).catch(err => {
      const action = 'suppression'
      commit(types.MAITRISES_ERROR, {action, err})
    })
  },
  reactivateMaitrise ({commit}, maitrise) {
    commit(types.LOADING, `Réactivation du maîtrise ${maitrise.nom} ${maitrise.prenom}`)
    api.reactivateMaitrise(maitrise.id)
      .then((res) => {
        console.log('reactivation res ===>', res.data)
        let reactivatedMaitrise = res.data
        commit(types.MAITRISE_UPDATED, reactivatedMaitrise)
      }).catch(err => {
      var action = 'modification'
      commit(types.MAITRISES_ERROR, {action, err})
    })
  },
  updateMaitriseFilter ({state}) {
    state.maitrises.treeSelectMaitrises.forEach((mait) => {
      const found = !state.maitrises.filteredMaitrises.find((maitrise) => maitrise.id === mait.id)
      if (found) {
        removeFromArray(state.maitrises.filters.idMaitrises, mait)
      }
    })
  },
  fetchMaitrisesByVilleId ({commit, state}) {
    commit(types.LOADING, 'Récupération des maîtrises')
    api.getAllMaitrisesByVilleId(state.currentVille.id, state.currentUser.arrondissement_id)
      .then((res) => {
        let fetchedMaitrises = res.data.elements
        fetchedMaitrises.sort((a, b) => a.nom.localeCompare(b.nom))
        console.log('by ville', fetchedMaitrises)
        commit(types.MAITRISES_FETCHED, fetchedMaitrises)
        EventBus.$emit('notify', {
          title: 'Maîtrises récupérés.',
          type: 'success',
        })
      }).catch(err => {
      var action = 'récupération'
      commit(types.MAITRISES_ERROR, {action, err})
    })

  },

  fetchAllMaitrises ({commit, state}) {
    commit(types.LOADING, 'Récupération des maîtrises')
    api.getAllMaitrises()
      .then((res) => {
        let fetchedMaitrises = res.data.elements
        commit(types.ALL_MAITRISES_FETCHED, fetchedMaitrises)
        EventBus.$emit('notify', {
          title: 'Maîtrises récupérés.',
          type: 'success',
        })
      }).catch(err => {
      var action = 'récupération'
      commit(types.MAITRISES_ERROR, {action, err})
    })

  },

  //
  // Arrondissements
  //

  fetchAllArrondissements ({commit}) {
    api.getAllArrondissements()
      .then((res) => {
        console.log('all arrondissements', res.data.elements)
        let fetchedArrondissements = res.data.elements
        commit(types.ALL_ARRONDISSEMENTS_FETCHED, fetchedArrondissements)
      }).catch(err => {
      const action = 'récupération'
      commit(types.ALL_ARRONDISSEMENTS_ERROR, {action, err})
    })

  },

  //
  // Materiels
  //

  fetchMaterielPermissByVilleId ({commit, state}) {
    api.getAllMaterielPermissByVilleId(state.currentVille.id)
      .then((res) => {
        let fetchedMaterielsPermis = res.data.elements
        commit(types.MATERIELSPERMIS_FETCHED, fetchedMaterielsPermis)
      }).catch(err => {
      const action = 'récupération'
      commit(types.MATERIELSPERMIS_ERROR, {action, err})
    })

  },
  fetchMaterielsByVilleId ({commit, state}) {
    commit(types.LOADING, 'Récupération des Matériaux')
    api.getAllMaterielsByVilleId(state.currentVille.id, state.currentUser.arrondissement_id)
      .then((res) => {
        let fetchedMateriels = res.data.elements
        fetchedMateriels.sort((a, b) => a.nom.localeCompare(b.nom))
        console.log('by ville', fetchedMateriels)
        commit(types.MATERIELS_FETCHED, fetchedMateriels)
      }).catch(err => {
      var action = 'récupération'
      commit(types.MATERIELS_ERROR, {action, err})
    })

  },
  createMateriel ({commit, state}, materiel) {
    commit(types.LOADING, `Création du materiel ${materiel.nom}`)
    console.log('actions materiel ==>', materiel)
    const body = {
      'actif': true,
      'nom': materiel.nom.trim(),
      'materielType': materiel.materielType,
      'arrondissement_id': materiel.arrondissement_id,
      'ville_id': state.currentVille.id,
    }
    api.createMateriel(body)
      .then((res) => {
        console.log(res)
        let createdMateriel = res.data
        commit(types.MATERIEL_CREATED, createdMateriel)
      }).catch(err => {
      console.log('err => ', err)
      const action = 'création'
      commit(types.MATERIELS_ERROR, {action, err})
    })
  },
  updateMateriel ({commit}, materiel) {
    const body = {
      'nom': materiel.nom.trim(),
      'materielType': materiel.materielType,
      'arrondissement_id': materiel.arrondissement_id
    }
    console.log('materiel body sent ========', body)
    api.updateMateriel(body, materiel.id)
      .then((res) => {
        console.log(res)
        let updatedMateriel = res.data
        commit(types.MATERIEL_UPDATED, updatedMateriel)
      }).catch(err => {
      var action = 'modification'
      commit(types.MATERIELS_ERROR, {action, err})
    })
  },
  deactivateMateriel ({commit, state}, materiel) {
    commit(types.LOADING, `Désactivation du materiel ${materiel.nom}`)
    api.deactivateMateriel(materiel.id)
      .then((res) => {
        console.log('deactivation res ===>', res.data)
        let deactivatedMateriel = res.data
        commit(types.MATERIEL_DEACTIVATED, deactivatedMateriel)
      }).catch(err => {
      const action = 'suppression'
      commit(types.MATERIEL_ERROR, {action, err})
    })
  },
  fetchAllMateriels ({commit, state}) {
    api.getAllMateriels()
      .then((res) => {
        let fetchedContenants = res.data.elements
        commit(types.ALL_MATERIELS_FETCHED, fetchedContenants)
      }).catch(err => {
      var action = 'récupération'
      commit(types.MATERIEL_ERROR, {action, err})
    })
  },
  fetchMaterielsOfVille ({commit, state}) {
    api.getMaterielsOfVille(state.currentVille.id).then(function (res) {
      let materiels = res.data.elements

      materiels.sort((a, b) => a.nom.localeCompare(b.nom))

      commit(types.MATERIELS_FETCHED, materiels)
      console.log('debug-end of fetchMaterielsOfVille')
    })
  },

  //
  // Secteurs
  //

  fetchSecteursByVilleId ({commit, state}) {
    commit(types.LOADING, 'Récupération des secteurs')
    api.getAllSecteursByVilleId(state.currentVille.id, state.currentUser.arrondissement_id)
      .then((res) => {
        console.log('by ville', res.data.elements)
        let fetchedSecteurs = res.data.elements
        commit(types.SECTEURS_FETCHED, fetchedSecteurs)
        EventBus.$emit('notify', {
          title: 'Secteurs récupérés.',
          type: 'success',
        })
      }).catch(err => {
      var action = 'récupération'
      commit(types.SECTEURS_ERROR, {action, err})
    })

  },
  createSecteur ({commit, state}, secteur) {
    commit(types.LOADING, `Création du secteur ${secteur.nom}`)
    const body = {
      'actif': true,
      'nom': secteur.nom.trim(),
      'arrondissement_id': secteur.arrondissement_id,
      'ville_id': state.currentVille.id,
    }
    api.createSecteur(body)
      .then((res) => {
        console.log(res)
        let createdSecteur = res.data
        commit(types.SECTEUR_CREATED, createdSecteur)
      }).catch(err => {
      const action = 'création'
      commit(types.SECTEUR_ERROR, {action, err})
    })
  },
  deactivateSecteur ({commit, state}, secteur) {
    commit(types.LOADING, `Désactivation du secteur ${secteur.nom} ${secteur.prenom}`)
    api.deactivateSecteur(secteur.id)
      .then((res) => {
        console.log('deactivation res ===>', res.data)
        let deactivatedSecteur = res.data
        commit(types.SECTEUR_DEACTIVATED, deactivatedSecteur)
      }).catch(err => {
      const action = 'suppression'
      commit(types.SECTEUR_ERROR, {action, err})
    })
  },
  updateSecteur ({commit}, secteur) {
    console.log('actions v2 update secteur ==>', secteur)
    // bind contacts to secteur
    const body = {
      'nom': secteur.nom.trim(),
      'arrondissement_id': secteur.arrondissement_id
    }
    console.log('secteur body sent ========', body)
    api.updateSecteur(body, secteur.id)
      .then((res) => {
        console.log(res)
        let updatedSecteur = res.data
        commit(types.SECTEUR_UPDATED, updatedSecteur)
      }).catch(err => {
      const action = 'modification'
      commit(types.SECTEUR_ERROR, {action, err})
    })
  },

  //
  // Cantonniers
  //

  fetchCantonniersOfVille ({commit, state}) {
    api.getCantonniersOfCurrentVille(state.currentVille.id).then(function (res) {
      let cantonniers = res.data.elements
      commit(types.CANTONNIERS_FETCHED, cantonniers)
      console.log('debug-end of fetchCantonniersOfVille')
    })
  },
  fetchAllCantonniersOfVille ({commit, state}) {
    return new Promise((resolve, reject) => {
      api.getCantonniersOfCurrentVille(state.currentVille.id).then(function (res) {
        let cantonniers = res.data.elements
        commit(types.ALL_CANTONNIERS_FETCHED, cantonniers)
        resolve()
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  createCantonnier ({commit, state}, cantonnier) {
    commit(types.LOADING, `Création du cantonnier ${cantonnier.nom} ${cantonnier.prenom}`)
    const body = {
      'actif': true,
      'nom': cantonnier.nom.trim(),
      'prenom': cantonnier.prenom.trim(),
      'arrondissement_id': cantonnier.arrondissement_id,
      'ville_id': state.currentVille.id
    }
    api.createCantonnier(body)
      .then((res) => {
        console.log('deactivation res ===>', res.data)
        let createdCantonnier = res.data
        commit(types.CANTONNIER_CREATED, createdCantonnier)
      }).catch(err => {
      const action = 'suppression'
      commit(types.CANTONNIERS_ERROR, {action, err})
    })
  },
  deactivateCantonnier ({commit, state}, cantonnier) {
    commit(types.LOADING, `Désactivation du cantonnier ${cantonnier.nom} ${cantonnier.prenom}`)
    api.deactivateCantonnier(cantonnier.id)
      .then((res) => {
        console.log('deactivation res ===>', res.data)
        let deactivatedCantonnier = res.data
        commit(types.CANTONNIER_DEACTIVATED, deactivatedCantonnier)
      }).catch(err => {
      const action = 'suppression'
      commit(types.CANTONNIERS_ERROR, {action, err})
    })
  },
  updateCantonnier ({commit, state}, cantonnier) {
    commit(types.LOADING, `Mise à jour du cantonnier ${cantonnier.nom} ${cantonnier.prenom}`)
    const body = {
      'actif': true,
      'nom': cantonnier.nom.trim(),
      'prenom': cantonnier.prenom.trim(),
      'arrondissement_id': cantonnier.arrondissement_id,
      'ville_id': state.currentVille.id
    }
    console.log('cantonnier body sent ========', body)
    api.updateCantonnier(body, cantonnier.id)
      .then((res) => {
        console.log(res)
        let updatedCantonnier = res.data
        commit(types.CANTONNIER_UPDATED, updatedCantonnier)
      }).catch(err => {
      const action = 'modification'
      commit(types.CANTONNIERS_ERROR, {action, err})
    })
  },
  fetchCantonniersByVilleId ({commit, state}) {
    commit(types.LOADING, 'Récupération des cantonniers')
    api.getAllCantonniersByVilleId(state.currentVille.id, state.currentUser.arrondissement_id)
      .then((res) => {
        let fetchedCantonniers = res.data.elements
        fetchedCantonniers.sort((a, b) => a.nom.localeCompare(b.nom))
        commit(types.CANTONNIERS_FETCHED, fetchedCantonniers)
        EventBus.$emit('notify', {
          title: 'Cantonniers récupérés.',
          type: 'success',
        })
      }).catch(err => {
      const action = 'récupération'
      commit(types.CANTONNIERS_ERROR, {action, err})
    })

  },

  //
  // Maps
  //

  searchRealTimeTournees ({commit, state}, {mode}) {  // Recherche les tournées terminées pour un date donnée
    console.log('the mode => ', mode)
    api.getRealTimeTournees(dateFormatter(new Date()), mode).then(function (res) {
      commit(types.REALTIME_TOURNEES, res.data.elements)
    })
  },
  setMapFilter ({commit}, infos) {
    commit(types.MAP_FILTER, infos)
  },
  searchTournee ({commit, state}, {filters}) {  // Recherche les tournées terminées pour un date donnée
    api.getTourneeById(filters.idTournee).then(function (res) {
      commit(types.REMONTEES_GPS_FETCHED, res.data)
    })
  },
  searchTournees ({commit, state}, {filters}) {  // Recherche les tournées terminées pour un date donnée
    commit(types.LOADING, 'Récupération des tournées')
    console.log('geted filter => ', filters)
    api.getTourneesOnlyByDate(dateFormatter(filters.date)).then(function (res) {
      commit(types.TOURNEES_FETCHED, res.data.elements)
    })
  },
  searchInfoTournee ({commit, state}, {idTournee}) {  // Recherche les tournées terminées pour un date donnée

    let tournee = state.map.result.tournees.find(t => t.id === idTournee)
    let cantonnier = state.cantonniers.data.find(c => c.id === tournee.cantonnier_id)
    let materiel = state.materiels.data.find(m => m.id === tournee.materiel_id)

    const date1 = new Date(tournee.startedAt)
    const date2 = new Date(tournee.endedAt)

    console.log('date2 => ', date2)
    const diffMilliseconds = Math.abs(date2 - date1)
    const diffHours = Math.floor(diffMilliseconds / 3600000)
    const diffMinutes = Math.floor((diffMilliseconds % 3600000) / 60000)

    const duree = `${diffHours.toString().padStart(2, '0')}h${diffMinutes.toString().padStart(2, '0')}`

    let info = {
      idMateriel: materiel.id,
      nomMateriel: materiel.nom,
      cantonnier: cantonnier.nom + ' ' + cantonnier.prenom,
      duree: !isNaN(date2) ? duree : 'En cours'
    }
    commit(types.INFO_TOURNEE, {info})

  },
  filterTournees ({commit, state}, {filters}) {  // Recherche les tournées terminées pour un date donnée
    commit(types.TOURNEES_FILTERED, filters.idMateriel)
  },

  //
  // Declarations
  //

  searchDeclarations ({commit, state}, {filters}) {
    commit(types.LOADING, 'Récupération des déclarations')
    api.getTourneesByDate(dateFormatter(filters.date)).then(function (res) {

      let filtredTournees = []
      let tournees = res.data.elements
      if (state.currentUser.arrondissementName.includes('2') || state.currentUser.arrondissementName.includes('Sud')) {
        tournees.forEach((t) => {
          if (t.remonteeGPSs.length > 0) {
            let arrondissement = state.currentVille.secteurs.find(s => s.id === t.remonteeGPSs[0].secteur_id).arrondissement_id
            if (arrondissement === state.currentUser.arrondissement_id) {
              filtredTournees.push(t)
            }
          }
        })
        tournees = filtredTournees
      }

      let arr_declarations = []
      let declarations_info = []
      tournees.forEach((t) => {
        console.log(t.declarations.length)
        arr_declarations.push(t.declarations)
        declarations_info.push({'tournee': t.id, 'materiel': t.materiel_id})
      })
      let declarations = [].concat(...arr_declarations)
      console.log('setted infos => ', declarations_info)
      console.log('setted declara => ', arr_declarations)
      commit(types.DECLARATIONS_FETCHED, {
        'data': declarations,
        'info': declarations_info
      })
    })
  },
  fetchSecteursOfVille ({commit, state}) {
    return new Promise((resolve, reject) => {
    api.getSecteursOfVille(state.currentVille.id).then(function (res) {
      let secteurs = res.data.elements

      secteurs.sort((a, b) => a.nom.localeCompare(b.nom))

      commit(types.SECTEURS_FETCHED, secteurs)
      resolve()
    })
    })
  },

  //
  // Contenants
  //

  fetchContenantsOfVille ({commit, state}, {arg}) {
    commit(types.LOADING, 'Récupération des contenants')
    api.getContenantsOfVille(state.currentVille.id).then(function (res) {
      let contenants = res.data.elements
      commit(types.CONTENANTS_FETCHED, {contenants, arg})
    })
      .catch(err => {
        const action = 'récupération'
        console.log("erreuuuuur : " , err)
        commit(types.CONTENANTS_ERROR, {action, err})
      })
  },
  fetchAllContenants ({commit, state}) {
    api.getAllContenants(state.currentVille.id)
      .then((res) => {
        let fetchedContenants = res.data.elements
        commit(types.ALL_CONTENANTS_FETCHED, fetchedContenants)
      }).catch(err => {
      var action = 'récupération'
      commit(types.CONTENANTS_ERROR, {action, err})
    })
  },
  filterContenant ({commit, state}, {filters}) {
    commit(types.CONTENANTS_FILTERED, filters)
  },
  updateContenantsFilter ({state}) {
    var removeFromArray = function (arr, elem) {
      const idx = arr.indexOf(elem)
      if (idx !== -1) arr.splice(idx, 1)
    }
    // update secteurs drop-down list
    _.each(state.contenants.availableSecteurs[0].children, function (sec) {
      var founded = !_.find(state.contenants.filtredContenants, function (contenant) {
        return contenant.secteur_id === sec.id
      })
      if (founded) {
        sec.isDisabled = true
        removeFromArray(state.contenants.filters.idSecteurs, sec.id)
      } else {
        sec.isDisabled = false
      }
    })
    // update numéros de contenants drop-down list
    _.each(state.contenants.availablesNumeros[0].children, function (num) {
      var founded = !_.find(state.contenants.filtredContenants, function (contenant) {
        return contenant.id === num.id
      })
      if (founded) {
        num.isDisabled = true
        removeFromArray(state.contenants.filters.idNumeros, num.id)
      } else {
        num.isDisabled = false
      }
    })
    // update adresse de contenants drop-down list
    _.each(state.contenants.availablesAdresses[0].children, function (ad) {
      console.log('ad => ', ad)
      var founded = !_.find(state.contenants.filtredContenants, function (contenant) {
        console.log('contenant => ', contenant)
        return contenant.adresse === ad.id
      })
      if (founded) {
        ad.isDisabled = true
        removeFromArray(state.collectes.filters.idAdresses, ad.id)
      } else {
        ad.isDisabled = false
      }
    })
  },
  deactivateContenant ({commit, state}, contenant) {
    commit(types.LOADING, `Désactivation du contenant ${contenant.reference}`)
    api.deactivateContenant(contenant.id)
      .then((res) => {
        console.log('deactivation res ===>', res.data)
        let deactivatedContenant = res.data
        commit(types.CONTENANT_DEACTIVATED, deactivatedContenant)
      }).catch(err => {
      const action = 'suppression'
      commit(types.CONTENANTS_ERROR, {action, err})
    })
  },
  updateContenant ({commit, state}, contenant) {
    commit(types.LOADING, `Mise à jour du contenant ${contenant.reference}`)
    console.log('actions contenant ==>', contenant)
    const body = {
      'reference': contenant.reference,
      'adresse': contenant.adresse.trim(),
      'numero': contenant.numero,
      'typeContenant': contenant.typeContenant.trim(),
      'arrondissement_id': contenant.arrondissement_id,
      'secteur_id': contenant.secteur_id,
      'ville_id': state.currentVille.id,
      'lat': contenant.lat,
      'lon': contenant.lon,
    }
    console.log('actions body ==>', body)
    api.updateContenant(body, contenant.id)
      .then((res) => {
        console.log(res)
        let createdContenant = res.data
        commit(types.CONTENANT_UPDATED, createdContenant)
      }).catch(err => {
      const action = 'création'
      commit(types.CONTENANTS_ERROR, {action, err})
    })
  },
  createContenant ({commit, state}, contenant) {
    commit(types.LOADING, `Création du contenant ${contenant.reference}`)
    console.log('actions contenant ==>', contenant)
    const body = {
      'actif': true,
      'reference': contenant.reference,
      'adresse': contenant.adresse.trim(),
      'numero': contenant.numero,
      'typeContenant': contenant.typeContenant.trim(),
      'lat': contenant.lat,
      'lon': contenant.lon,
      'tauxDeRemplissage': 0.00,
      'nombreDeCollecte': 0,
      'arrondissement_id': contenant.arrondissement_id,
      'secteur_id': contenant.secteur_id,
      'ville_id': state.currentVille.id,
    }
    console.log('actions body ==>', body)
    api.createContenant(body)
      .then((res) => {
        console.log(res)
        let createdContenant = res.data
        commit(types.CONTENANT_CREATED, createdContenant)
      }).catch(err => {
      const action = 'création'
      commit(types.CONTENANTS_ERROR, {action, err})
    })
  },

  //
  // Collectes
  //

  generateCollectesReporting ({commit, state}) {
    let csvContent = ''
    api.getAllContenantsByVilleId(state.currentVille.id)
      .then((res) => {
        let fetchedContenants = res.data.elements
        fetchedContenants.sort((a, b) => {
          let refA = a.reference || ''
          let refB = b.reference || ''
          return refA.localeCompare(refB)
        })
        csvContent += CsvExport.forgeCollectesCSVFile(fetchedContenants) + CsvExport.getLinebreak()
        CsvExport.promptCsvDownloadCollectes(csvContent, state.currentVille.name)
        commit(types.CSV_SUCCESS)
      }).catch(err => {
      const action = 'récupération'
      commit(types.USERS_ERROR, {action, err})
    })

  },
  downloadTemplateFile ({commit}) {
    commit(types.LOADING, `Téléchargement en cours`)
    var wb = XLSX.utils.book_new()
    wb.Props = {
      Title: 'Template collecte',
      Subject: 'Fichier d\'import des nouvelles collectes',
      Author: 'Cantonniers',
      CreatedDate: moment().format('YYYY-MM-DD'),
    }
    wb.SheetNames.push('Feuille1')
    var wsData = [['ID', 'TYPE', 'X', 'Y', 'SECTEUR', 'ADRESSE', 'NUMERO',],]
    var ws = XLSX.utils.aoa_to_sheet(wsData)
    wb.Sheets['Feuille1'] = ws
    var wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'binary'})

    function s2ab (s) {
      var buf = new ArrayBuffer(s.length)
      var view = new Uint8Array(buf)
      for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
      return buf
    }

    // saveAs(new window.Blob([ s2ab(wbout), ], {type: 'application/octet-stream'}), 'template.xlsx')
    var templateFile = new window.Blob([s2ab(wbout),], {type: 'application/octet-stream'})
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(templateFile, 'template.xlsx')
    } else {
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(templateFile)
      link.setAttribute('download', `template.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
    commit(types.COLLECTE_DOWNLOAD_TEMPLATE_FILE)
  },

  //
  // Errors
  //

  showErrorMessage ({commit, state}, message) {
    commit(types.CSV_ERROR_UNDEFINED, message)
  },

  //
  // Demandes
  //

  fetchDemandesByVilleId ({commit, state}) {
    return new Promise((resolve, reject) => {
      commit(types.LOADING, 'Récupération des demandes')
      api.getAllDemandesByVilleId(state.currentVille.id)
        .then((res) => {
          console.log('demandes by ville :' + state.currentVille.id, res.data.elements)
          let fetchedDemandes = res.data.elements
          fetchedDemandes = fetchedDemandes.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
          commit(types.DEMANDES_FETCHED, fetchedDemandes)
          resolve()
        }).catch(err => {
        var action = 'récupération'
        reject(err)
        commit(types.DEMANDES_ERROR, {action, err})
      })
    })
  },
  updateDemande ({commit, state}, demande) {
    commit(types.LOADING, `Mise à jour d'une demande`)
    const body = {
      'actif': true,
      'objet': demande.objet,
      'priority': demande.priority,
      'lat': demande.lat,
      'lon': demande.lon,
      'cantonnier_id': demande.cantonnier_id,
    }
    api.updateDemande(body, demande.id)
      .then((res) => {
        console.log(res)
        let updatedDemande = res.data
        commit(types.DEMANDE_UPDATED, updatedDemande)
      }).catch(err => {
      const action = 'modification'
      commit(types.DEMANDES_ERROR, {action, err})
    })
  },
  cancelDemande ({commit, state}, demande) {
    commit(types.LOADING, `Annulation d'une demande`)
    const body = {
      'actif': false,
      'statusDemande': demandeStatut.STATUT_ANNULEE,
      'commentaireAnnulation': demande.commentaireAnnulation,
    }
    api.cancelDemande(body, demande.id)
      .then((res) => {
        console.log(res)
        let updatedDemande = res.data
        commit(types.DEMANDE_CANCELED, updatedDemande)
      }).catch(err => {
      const action = 'modification'
      commit(types.DEMANDES_ERROR, {action, err})
    })
  },
  updateDemandesCantoFilter ({state}) {

    const cantonniersToRemove = []
    const datesToRemove = []
    var removeFromArray = function (arr, elem) {
      console.log(arr, elem)
      const idx = arr.indexOf(elem)
      if (idx !== -1) arr.splice(idx, 1)
    }

    // update cantoniers drop-down list
    _.each(state.demandes.availablesCantonniers[0].children, function (canto) {
      // console.log(canto)
      var founded = !_.find(state.demandes.filtredDemandes, function (demande) {
        // console.log(demande.cantonnier.nom)
        return demande.cantonnier_id === canto.id
      })
      if (founded) {
        canto.isDisabled = true
        cantonniersToRemove.push(canto.id)
        console.log(state.demandes.filters.idCantonniers, canto.id)
        removeFromArray(state.demandes.filters.idCantonniers, canto.id)
      } else {
        canto.isDisabled = false
      }
      state.demandes.availablesCantonniers[0].children = state.demandes.availablesCantonniers[0].children.filter(canto => {
        return !cantonniersToRemove.includes(canto.id)
      })
    })
    console.log('deb-demande => ', state.demandes.availablesCantonniers[0].children)
    // update days drop-down list
    _.each(state.demandes.availableDates[0].children, function (date) {
      var founded = !_.find(state.demandes.filtredDemandes, function (demande) {
        return demande.day === date.id
      })
      if (founded) {
        date.isDisabled = true
        datesToRemove.push(date.id)
        removeFromArray(state.demandes.filters.daysList, date.id)
      } else {
        date.isDisabled = false
      }
      state.demandes.availableDates[0].children = state.demandes.availableDates[0].children.filter(date => {
        return !datesToRemove.includes(date.id)
      })
    })
  },
  generateDemandesReporting ({commit, state}) {
    let csvContent = ''
    api.getAllDemandesByVilleId(state.currentVille.id)
      .then((res) => {
        let fetchedDemandes = res.data.elements
        csvContent += CsvExport.forgeDemandesCSVFile(fetchedDemandes) + CsvExport.getLinebreak()
        CsvExport.promptCsvDownloadDemandes(csvContent, false, state.currentVille.name)
        commit(types.CSV_SUCCESS)
      }).catch(err => {
      const action = 'récupération'
      commit(types.USERS_ERROR, {action, err})
    })

  },
  createDemande ({commit, state}, demande) {
    commit(types.LOADING, `Création d'une nouvelle demande`)
    const body = {
      'actif': true,
      'day': getFormattedDate(),
      'objet': demande.objet,
      'statusDemande': demande.statusDemande,
      'priority': demande.priority,
      'lat': demande.lat,
      'lon': demande.lon,
      'cantonnier_id': demande.cantonnier_id,
      'maitrise_id': state.currentUser.id,
      'ville_id': state.currentVille.id,
    }
    api.createDemande(body)
      .then((res) => {
        console.log(res)
        let createdDemande = res.data
        commit(types.DEMANDE_CREATED, createdDemande)
      }).catch(err => {
      const action = 'création'
      commit(types.DEMANDES_ERROR, {action, err})
    })
  },

  clearDemandeCancellationErrors ({commit, state}) {
    commit(types.DEMANDE_CANCELLATION_CLEAR)
  },

  reloadDemandes ({commit}) {
    commit(types.RELOAD_DEMANDS)
  },

  //
  // Users
  //

  generateUsersReporting ({commit, state}) {
    let csvContent = ''
    api.getAllUsers()
      .then((res) => {
        console.log('all users', res.data.elements)
        let fetchedUsers = res.data.elements
        fetchedUsers.sort((a, b) => a.nom.localeCompare(b.nom))
        csvContent += CsvExport.forgeUsersCSVFile(fetchedUsers) + CsvExport.getLinebreak()
        CsvExport.promptCsvDownloadUsers(csvContent)
        commit(types.CSV_SUCCESS)
      }).catch(err => {
      const action = 'récupération'
      commit(types.USERS_ERROR, {action, err})
    })
  },
  getStatistiques ({commit, state}, {id_ville, year}) {
    return new Promise((resolve, reject) => {
      api.getStatistiquesForVille(id_ville, year)
        .then(function (res) {
          console.log('res => ', res)
          commit(types.KPI, res.data)
          resolve() // Resolve the promise after the action is completed
        })
        .catch(function (error) {
          reject(error) // Reject the promise if there's an error
        })
    })
  },
  fetchAllUsers ({commit, state}) {
    commit(types.LOADING, 'Récupération des utilisateurs')
    api.getAllUsers()
      .then((res) => {
        console.log('all users', res.data.elements)
        let fetchedUsers = res.data.elements
        fetchedUsers.sort((a, b) => a.nom.localeCompare(b.nom))
        commit(types.USERS_FETCHED, fetchedUsers)
        EventBus.$emit('notify', {
          title: 'Utilisateurs récupérés.',
          type: 'success',
        })
      }).catch(err => {
      const action = 'récupération'
      commit(types.USERS_ERROR, {action, err})
    })
  },
  createUser ({commit, state}, maitrise) {
    commit(types.LOADING, `Création du maîtrise ${maitrise.nom} ${maitrise.prenom}`)
    console.log('actions maitrise ==>', maitrise)
    const body = {
      'actif': true,
      'telephone': maitrise.telephone,
      'login': maitrise.login,
      'password': maitrise.password,
      'email': maitrise.email,
      'nom': maitrise.nom,
      'prenom': maitrise.prenom,
      'isSuperAdmin': maitrise.isSuperAdmin,
      'isCollectivite': maitrise.isCollectivite,
      'arrondissement_id': maitrise.arrondissement_id,
      'ville_id': maitrise.ville_id
    }
    api.createUser(body)
      .then((res) => {
        console.log(res)
        let createdMaitrise = res.data
        commit(types.USER_CREATED, createdMaitrise)
      }).catch(err => {
      const action = 'création'
      commit(types.USERS_ERROR, {action, err})
    })
  },
  updateAllUsersFilter ({state}) {
    state.adminUsers.treeSelectAdminUsers.forEach((mait) => {
      const found = !state.adminUsers.filteredAdminUsers.find((maitrise) => maitrise.id === mait.id)
      if (found) {
        removeFromArray(state.adminUsers.filters.idUsers, mait)
      }
    })
  },
  deactivateUser ({commit}, maitrise) {
    commit(types.LOADING, `Désactivation du maîtrise ${maitrise.nom} ${maitrise.prenom}`)
    api.deactivateUser(maitrise.id)
      .then((res) => {
        console.log('deactivation res ===>', res.data)
        let updatedMaitrise = res.data
        commit(types.USER_DEACTIVATED, updatedMaitrise)
      }).catch(err => {
      const action = 'suppression'
      commit(types.USERS_ERROR, {action, err})
    })
  },
  deleteUser ({commit}, maitrise) {
    commit(types.LOADING, `Suppréssion définitive du maîtrise ${maitrise.nom} ${maitrise.prenom}`)
    api.deleteUser(maitrise.id)
      .then((res) => {
        commit(types.USER_DELETED, maitrise)
      }).catch(err => {
      const action = 'suppression définitive'
      commit(types.USERS_ERROR, {action, err})
    })
  },
  reactivateUser ({commit}, maitrise) {
    commit(types.LOADING, `Réactivation du maîtrise ${maitrise.nom} ${maitrise.prenom}`)
    api.reactivateUser(maitrise.id)
      .then((res) => {
        console.log('reactivation res ===>', res.data)
        let reactivatedMaitrise = res.data
        commit(types.USER_UPDATED, reactivatedMaitrise)
      }).catch(err => {
      const action = 'modification'
      commit(types.USERS_ERROR, {action, err})
    })
  },
  updateUser ({commit}, maitrise) {
    console.log('actions v2 update user ==>', maitrise)

    const body = {
      'telephone': maitrise.telephone,
      'actif': maitrise.actif,
      'login': maitrise.login,
      'password': maitrise.password,
      'email': maitrise.email,
      'nom': maitrise.nom,
      'prenom': maitrise.prenom,
      'isSuperAdmin': maitrise.isSuperAdmin,
      'contacts': maitrise.contacts,
      'arrondissement_id': maitrise.arrondissement_id,
      'ville_id': maitrise.ville_id

    }
    console.log('maitrise body sent ========', body)
    api.updateUser(body, maitrise.id)
      .then((res) => {
        console.log(res)
        let updatedMaitrise = res.data
        commit(types.USER_UPDATED, updatedMaitrise)
      }).catch(err => {
      const action = 'modification'
      commit(types.USERS_ERROR, {action, err})
    })
  },

  //
  // Villes
  //

  updateModulesOfVille ({commit, state}, {selectedVille, module}) {
    var changedModules = []
    console.log('Module => ', module)
    let ville = state.villes.data.find(v => v.id === selectedVille.id)

    if (module === 'BO') {
      // filtrer par les modules bo changés
      changedModules = selectedVille.parametragebos.filter(obj1 => {
        const obj2 = ville.parametragebos.find(o => o.id === obj1.id)
        return Object.keys(obj1).some(actif => obj1[actif] !== obj2[actif])
      })

      for (const module of changedModules) {
        console.log('ze module => ', module)
        api.updateModuleBo(module).then(res => {
          commit(types.MODULE_BO_UPDATED, {module, selectedVille})
        })
      }
    } else {
      // filtrer par les modules APK changés
      changedModules = selectedVille.parametrageapks.filter(obj1 => {
        const obj2 = ville.parametrageapks.find(o => o.id === obj1.id)
        return Object.keys(obj1).some(actif => obj1[actif] !== obj2[actif])
      })

      for (const module of changedModules) {
        console.log('ze module => ', module)
        api.updateModuleApk(module).then(res => {
          commit(types.MODULE_APK_UPDATED, module)
        })
      }
    }

    console.log('changedModules => ', changedModules)

  },
  fetchAllVilles ({commit}) {
    commit(types.LOADING, 'Récupération des villes')
    api.getAllVilles()
      .then((res) => {
        console.log('all villes', res.data.elements)
        let fetchedVilles = res.data.elements
        commit(types.ALL_VILLES_FETCHED, fetchedVilles)
      }).catch(err => {
      const action = 'récupération'
      commit(types.VILLES_ERROR, {action, err})
    })
  },

  //Tournees

  fetchTourneesByVilleId ({commit, state}) {
      commit(types.LOADING, 'Récupération des tournées')
      api.getAllTourneesByVilleId(state.currentVille.id)
        .then((res) => {
          console.log('by ville', res.data.elements)
          let fetchedTournees = res.data.elements
          commit(types.MODULE_TOURNEES_FETCHED, fetchedTournees)
          EventBus.$emit('notify', {
            title: 'Tournées récupérés.',
            type: 'success',
          })
        }).catch(err => {
        var action = 'récupération'
        commit(types.TOURNEES_ERROR, {action, err})
      })

    },

  //
  // Reporting
  //

  getMaterielsOfVille ({commit, state}) {
    api.getActifMaterielsByVilleId().then(function (res) {
      console.log(res)
      state.reporting.materiels = res.data.elements
    })
  },
  getCantonniersOfVille ({commit, state}) {
    api.getCantonniersByVilleId().then(function (res) {
      console.log(res)
      state.reporting.cantonniers = res.data.elements
    })
  },
  getSecteursOfVille ({commit, state}) {
    api.getSecteursByVilleId().then(function (res) {
      state.reporting.secteurs = res.data.elements
    })
  },
  getAvailableDates ({commit, state}) {
    return new Promise((resolve, reject) => {
      state.reporting.filters.daysList = [moment().format('YYYY-MM-DD')]
      console.log(state.reporting.filters.daysList)
      console.log(moment().format('ddd Do MMM YYYY'))
      api.getTourneesOnly().then(function (res) {
        console.log('Rep-The tournee only => ', res.data.elements)
        const sortedArray = res.data.elements.sort((a, b) => {
          const startedAtA = new Date(a.startedAt)
          const startedAtB = new Date(b.startedAt)
          if (startedAtA < startedAtB) {
            return -1
          } else if (startedAtA > startedAtB) {
            return 1
          } else {
            return 0
          }
        })
        console.log(sortedArray)
        state.reporting.allGeopassages = sortedArray
        const start = moment(sortedArray[0].startedAt, 'YYYY-MM-DD')
        const end = moment()
        const daysList = []
        const daysListGrouped = []
        let currentDate = start.clone()

        while (currentDate.isSameOrBefore(end)) {
          daysList.push(currentDate.clone())
          currentDate.add(1, 'days')
        }

        let yearGrouped = _.groupBy(daysList, function (d) {
          return d.year()
        })
        for (let yearKey in yearGrouped) {
          let yearDays = yearGrouped[yearKey]
          let monthGrouped = _.groupBy(yearDays, function (d) {
            return d.format('YYYY-MM')
          })
          let monthList = []
          for (let monthKey in monthGrouped) {
            monthList.push({
              label: monthGrouped[monthKey][0].format('MMMM YYYY'),
              id: monthKey,
              children: _.map(monthGrouped[monthKey], function (d) {
                const isDisabled = !d.isSame(moment(), 'day')
                return {
                  label: d.format('ddd Do MMM YYYY'),
                  id: d.format('YYYY-MM-DD'),
                  isDisabled: isDisabled && (() => {
                    for (let i = 0; i < sortedArray.length; i++) {
                      if (sortedArray[i].day === d.format('YYYY-MM-DD')) {
                        return false
                      }
                    }
                    return true
                  })(),
                }
              }),
            })

          }
          daysListGrouped.push({
            label: yearKey,
            id: yearKey,
            children: monthList,
          })
        }

        console.log(daysListGrouped)
        let daysL = _.cloneDeep(daysListGrouped)
        commit(types.REPORTING_FILTER_DATES, daysListGrouped)

        state.reporting.availableDates = daysL
        console.log(state.reporting.availableDates)
        resolve()
      })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  async getAvailableMateriels ({commit, state}) {
    return new Promise((resolve, reject) => {
      commit(types.LOADING, 'Récupération des données reporting')
      console.log('async available materiels')
      api.getTourneesOnly().then(async function (res) {
        console.log(res.data.elements)
        const sortedArray = res.data.elements.sort((a, b) => {
          const startedAtA = new Date(a.startedAt)
          const startedAtB = new Date(b.startedAt)
          if (startedAtA < startedAtB) {
            return -1
          } else if (startedAtA > startedAtB) {
            return 1
          } else {
            return 0
          }
        })
        try {
          const response = await api.getMaterielsOfVille(state.currentVille.id)
          console.log('state for reporting ===> ', state.currentVille.arrondissements)

          let mat = state.reporting.availableMateriel = [
            {
              id: '1',
              label: 'Tous',
              children: []
            }
          ]

          if (state.currentVille.arrondissements.length === 1) {
            const arrondissementId = state.currentVille.arrondissements[0].id
            const materiels = response.data.elements.filter(materiel => {
              // Replace 'arrondissement_id' with the actual property name in 'materiels' objects
              return materiel.arrondissement_id === arrondissementId
            }).map(materiel => {
              return {
                id: materiel.id,
                label: materiel.materielType + ':' + materiel.nom,
                isDisabled: (() => {
                  for (let i = 0; i < sortedArray.length; i++) {
                    if (sortedArray[i].materiel_id === materiel.id) {
                      return false
                    }
                  }
                  return true
                })(),
              }
            })

            mat[0].children.push({
              id: '2',
              label: state.currentVille.arrondissements[0].nom,
              children: materiels.filter(item => !item.isDisabled)
            })
          } else if (state.currentVille.arrondissements.length === 2) {
            state.currentVille.arrondissements.forEach((arrondissement, index) => {
              const arrondissementId = arrondissement.id
              const materiels = response.data.elements.filter(materiel => {
                // Replace 'arrondissement_id' with the actual property name in 'materiels' objects
                return materiel.arrondissement_id === arrondissementId
              }).map(materiel => {
                return {
                  id: materiel.id,
                  label: materiel.materielType + ':' + materiel.nom,
                  isDisabled: (() => {
                    for (let i = 0; i < sortedArray.length; i++) {
                      if (sortedArray[i].materiel_id === materiel.id) {
                        return false
                      }
                    }
                    return true
                  })(),
                }
              })

              mat[0].children.push({
                id: `2-${index}`,
                label: arrondissement.nom,
                children: materiels.filter(item => !item.isDisabled)
              })
            })

            // Sort the children array based on the arrondissement index in descending order
            mat[0].children.sort((a, b) => {
              const indexA = parseInt(a.label.split('-')[1])
              const indexB = parseInt(b.label.split('-')[1])
              return indexB - indexA
            })
          }

          console.log(mat)
          commit(types.REPORTING_FILTER_MATERIELS, mat)
          resolve()
        } catch (error) {
          commit(types.REPORTING_ERROR)
          console.error(error)
        }
        //  commit(types.REPORTING_FETCHED)
      }, function (err) {
        commit(types.REPORTING_ERROR)
      })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  async getAvailableCantonniers ({commit, state}) {
    return new Promise((resolve, reject) => {
      api.getTourneesOnly().then(async function (res) {
        console.log(res.data.elements)
        const sortedArray = res.data.elements.sort((a, b) => {
          const startedAtA = new Date(a.startedAt)
          const startedAtB = new Date(b.startedAt)
          if (startedAtA < startedAtB) {
            return -1
          } else if (startedAtA > startedAtB) {
            return 1
          } else {
            return 0
          }
        })
        try {
          const response = await api.getCantonniersByVilleId()
          const cantonniers = response.data.elements.map(cantonnier => {
            return {
              id: cantonnier.id,
              label: cantonnier.nom + ',' + cantonnier.prenom,
              isDisabled: (() => {
                for (let i = 0; i < sortedArray.length; i++) {
                  if (sortedArray[i].cantonnier_id === cantonnier.id) {
                    return false
                  }
                }
                return true
              })(),
            }
          })
          console.log('debug-> canto', cantonniers)
          let canto = _.cloneDeep(cantonniers)
          commit(types.REPORTING_FILTER_AGENTS, canto)
          state.reporting.availableAgents = [
            {
              id: '1',
              label: 'Tous',
              children: cantonniers.filter(item => !item.isDisabled)
            }
          ]
          resolve()
        } catch (error) {
          commit(types.REPORTING_ERROR)
          console.error(error)
          reject(error)
        }
      })
    })
  },
  updateReportingDatesFilter ({state}) {

    const initDatesFilter = _.cloneDeep(state.reportingFilter.dates)

    const availableDates = state.reporting.availableDates
    const tournee = state.reporting.allGeopassages
    const datesArray = []
    const materielsFilters = state.reporting.filters.idsMateriel
    const cantonniersFilters = state.reporting.filters.idAgent

    if (materielsFilters.length > 0) {
      _.forEach(tournee, function (t) {
        if (_.includes(materielsFilters, t.materiel_id)) {
          datesArray.push(t.day)
          availableDates.forEach(function (dates) {
            dates.children.forEach(function (child1) {
              child1.children.forEach(function (child2) {
                if (_.includes(datesArray, child2.id)) {
                  child2.isDisabled = false
                } else {
                  child2.isDisabled = true
                }
              })
            })
          })
        }
      })
    } else {
      state.reporting.availableDates = initDatesFilter
    }
  },
  updateReportingMaterielFilter ({state}) {

    console.log(state.reporting.filters.daysList)
    console.log('filter day list => ', state.reporting.filters.daysList)

    const initMaterielFilter = _.cloneDeep(state.reportingFilter.materiels)

    console.log('deb-init materiels => ', initMaterielFilter[0].children[0].children)

    const tournee = state.reporting.allGeopassages
    const daysFilters = state.reporting.filters.daysList
    let availableMateriels = initMaterielFilter
    const materielsArray = []

    state.reporting.availableMateriel = initMaterielFilter
    //console.log('deb-availableMateriels  => ', availableMateriels[0].children[0].children)

    //console.log('Rep-daysFilters => ', daysFilters)
    if (daysFilters.length > 0) {
      //console.log('Rep => ', 'I entered ')
      daysFilters.forEach(day => {
        //console.log('Rep => ', 'I entered Foreach ')
        _.forEach(tournee, function (t) {
          if (day.length === 10) {
            //console.log('mo-we choose day')
            if (_.includes(daysFilters, t.day)) {
              //console.log('mo-Kayna day => ', t.day)
              //console.log(t)
              materielsArray.push(t.materiel_id)
              availableMateriels.forEach(function (materiel) {
                materiel.children.forEach(function (child1) {
                  child1.children.forEach(function (child2) {
                    if (_.includes(materielsArray, child2.id)) {
                      child2.isDisabled = false
                      //console.log('Rep-isDis false => ', child2)
                    } else {
                      child2.isDisabled = true
                      //console.log('Rep-isDis true => ', child2)
                    }
                  })
                })
              })
            }
          }
          if (day.length === 7) {
            //console.log('mo-we choose month', t.day.substring(0, 7), day)
            if (_.includes(daysFilters, t.day.substring(0, 7))) {
              //console.log('mo-kayna => ', t.day, t.day.substring(0, 7))
              materielsArray.push(t.materiel_id)
              availableMateriels.forEach(function (materiel) {
                materiel.children.forEach(function (child1) {
                  child1.children.forEach(function (child2) {
                    if (_.includes(materielsArray, child2.id)) {
                      child2.isDisabled = false
                    } else {
                      child2.isDisabled = true
                    }
                  })
                })
              })
            }
          }
          if (day.length === 4) {
            //console.log('Rep-we choose year')
            if (_.includes(daysFilters, t.day.substring(0, 4))) {
              materielsArray.push(t.materiel_id)
              //console.log(t.materiel_id)
              availableMateriels.forEach(function (materiel) {
                materiel.children.forEach(function (child1) {
                  child1.children.forEach(function (child2) {
                    if (_.includes(materielsArray, child2.id)) {
                      child2.isDisabled = false
                    } else {
                      child2.isDisabled = true
                    }
                  })
                })
              })
            }
          }
        })
      })
      //console.log('Rep-materielsArray => ', materielsArray)
      //console.log('Rep-Availableee => ', state.reporting.availableMateriel)

      if (materielsArray.length === 0) {
        state.reporting.availableMateriel[0].children.forEach(function (arrondissement) {
          arrondissement.children.forEach(function (materiel) {
            materiel.isDisabled = true
          })
        })
      }

      //console.log('deb-else => ', state.reporting.availableMateriel[0].children)
      state.reporting.availableMateriel[0].children.forEach(function (arrondissement) {
        //console.log('Rep-child => ', arrondissement)
        let available = []
        arrondissement.children.forEach(function (materiel) {
          //console.log('deb-materiel => ', materiel)
          if (!materiel.isDisabled) {
            available.push(materiel)
          }
        })
        //console.log('mo-available => ', available)
        arrondissement.children = available
      })

    } else {
      //console.log('ELSEEEE', initMaterielFilter[0].children[0].children[7].isDisabled)
      state.reporting.availableMateriel = initMaterielFilter
      //console.log('initMaterielFilter => ', initMaterielFilter[0].children[0].children[7].isDisabled)
    }

    //console.log('deb-allData => ', state.reportingFilter.allDataMateriels)
  },
  updateReportingAgentFilter ({state}) {

    const initAgentFilter = _.cloneDeep(state.reportingFilter.agents)

    const availableCantonniers = initAgentFilter
    const tournee = state.reporting.allGeopassages
    const daysFilters = state.reporting.filters.daysList
    const materielsFilters = state.reporting.filters.idsMateriel
    const cantonniersArray = []
    var available = []

    console.log('deb-repo =>  ', daysFilters)
    console.log('deb-repo =>  ', materielsFilters)
    console.log('deb-repo-tournee =>  ', tournee)

    state.reporting.availableAgents = initAgentFilter
    if (daysFilters.length > 0 && materielsFilters.length > 0) {
      daysFilters.forEach(day => {
        //console.log('we are changing date so we disable some elements in agents')
        _.forEach(tournee, function (t) {
          if (day.length === 10) {
            if (day === t.day && _.includes(materielsFilters, t.materiel_id)) {
              cantonniersArray.push(t.cantonnier_id)
              availableCantonniers.forEach(function (cantonnier) {
                cantonnier.children.forEach(function (child1) {
                  if (_.includes(cantonniersArray, child1.id)) {
                    child1.isDisabled = false
                  } else {
                    child1.isDisabled = true
                  }
                })
              })
            }
          }
          if (day.length === 7) {
            if (day === t.day.substring(0, 7) && _.includes(materielsFilters, t.materiel_id)) {
              cantonniersArray.push(t.cantonnier_id)
              availableCantonniers.forEach(function (cantonnier) {
                cantonnier.children.forEach(function (child1) {
                  if (_.includes(cantonniersArray, child1.id)) {
                    child1.isDisabled = false
                  } else {
                    child1.isDisabled = true
                  }
                })
              })
            }
          }
          if (day.length === 4) {
            if (day === t.day.substring(0, 4) && _.includes(materielsFilters, t.materiel_id)) {
              cantonniersArray.push(t.cantonnier_id)
              availableCantonniers.forEach(function (cantonnier) {
                cantonnier.children.forEach(function (child1) {
                  if (_.includes(cantonniersArray, child1.id)) {
                    child1.isDisabled = false
                  } else {
                    child1.isDisabled = true
                  }
                })
              })
            }
          }
        })
      })
      state.reporting.availableAgents[0].children.forEach(function (agent) {
        console.log('deb-ag => ', agent)
        if (!agent.isDisabled) {
          available.push(agent)
        }
      })
      state.reporting.availableAgents[0].children = available
    } else {
      state.reporting.availableAgents = initAgentFilter
    }
  },
  async generateReporting ({commit, state}, filters) {
    //console.log('currentville => ', state.currentVille)
    commit(types.LOADING, 'Récupération des données reporting')
    const tournee = state.reporting.allGeopassages
    let matchingElementsInGeoPassage = []
    let tourneeWithRemontee = []
    let materiels = []
    let secteurs = []
    let cantonniers = []
    let arrondissements = state.currentVille.arrondissements
    let reporting = []
    let geopassagePromise = []
    let geopassages = []

    //if all filters are empty
    if (filters.daysList.length === 0 && filters.idsMateriel.length === 0 && filters.idAgent.length === 0) {
      console.log('none of the filters is selected')
      console.log('tournee first ==>', tournee)

      try {
        const tourneeIds = tournee.map(tournee => tournee.id)

        // Fetch unique tournee IDs
        const uniqueTourneeIds = Array.from(new Set(tourneeIds))
        console.log(uniqueTourneeIds)

        await api.getTournees(uniqueTourneeIds).then(function (res) {
            tourneeWithRemontee = res.data.elements
        })

        //console.log("tourneesssssss ==> ", tourneeWithRemontee);
        // Iterate over matchingElementsInGeoPassage
        for (const matchingTournee of tourneeWithRemontee) {
          const mat = _.find(state.materiels.data, {id: matchingTournee.materiel_id})
          const canto = _.find(state.cantonniers.data, {id: matchingTournee.cantonnier_id})
          materiels.push(mat)
          cantonniers.push(canto)

          for (const remontee of matchingTournee.remonteeGPSs) {
            const sec = _.find(state.reporting.secteurs, {id: remontee.secteur_id});
            if (sec) {
              secteurs.push(sec);

              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the remontee
              remontee.secteur = sec;
            }
          }
          // Adding secteur information to declarations
          for (const declaration of matchingTournee.declarations) {
            const sec = _.find(state.reporting.secteurs, {id: declaration.secteur_id});
            if (sec) {
              secteurs.push(sec);
              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the declaration
              declaration.secteur = sec;
            }
          }
          //console.log(state.materiels)
          //console.log('secteur check ===> ', secteurs)
          //console.log('arrond check ===> ', arrondissements)
        }

        console.log(state.reporting.materiels)
        console.log(state.materiels)
        console.log('materiels === >', materiels)
        console.log("tournee with remontee final please ==> ", tourneeWithRemontee)

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          let negativeVerifications = []

          for (let j = 0; j < tourneeWithRemontee[i].verifications.length; j++) {
            const verification = tourneeWithRemontee[i].verifications[j]
            if (verification.details !== 'OK' && verification.details !== 'PRESENT' &&
              verification.details !== 'PROPRE' && verification.details !== 'NOT/ACT' &&
              verification.details !== '100%') {
              negativeVerifications.push(verification)
            }
          }

          tourneeWithRemontee[i].negativeVerifications = negativeVerifications
      }

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          const {negativeVerifications, remonteeGPSs, declarations} = tourneeWithRemontee[i]

          const mergeRemonteeDeclarationVerification = [
            ...negativeVerifications,
            ...remonteeGPSs,
            ...declarations
          ]

          tourneeWithRemontee[i].mergeRemonteeDeclarationVerification = mergeRemonteeDeclarationVerification.sort((a, b) => {
            const dateA = new Date(parseInt(a.recordedAt))
            const dateB = new Date(parseInt(b.recordedAt))
            return dateA - dateB
          })
        }

        console.log(tourneeWithRemontee)
        console.log(geopassages)
        console.log('secteeeeurs wa lekher ==> ', secteurs)
        reporting = createReport(tourneeWithRemontee, secteurs, materiels, cantonniers, geopassages, photoUrl)
        console.log(reporting)
      } catch (error) {
        commit(types.REPORTING_ERROR)
        console.error(error)
      }
    }

    //if date is the only one selected
    if (filters.daysList.length !== 0 && filters.idsMateriel.length === 0 && filters.idAgent.length === 0) {
      console.log('date is the only one selected')
      console.log('tournee first ==>', tournee)
      for (let t of tournee) {
        for (let d of filters.daysList) {
          if (d.length === 4) {
            if (d === t.day.substring(0, 4)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
          if (d.length === 7) {
            if (d === t.day.substring(0, 7)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
          if (d.length === 10) {
            if (d === t.day) {
              matchingElementsInGeoPassage.push(t)
            }
          }
        }
      }
      console.log('tournee second ==> ', matchingElementsInGeoPassage)
      try {
        const tourneeIds = matchingElementsInGeoPassage.map(matchingTournee => matchingTournee.id)

        // Fetch unique tournee IDs
        const uniqueTourneeIds = Array.from(new Set(tourneeIds))
        console.log(uniqueTourneeIds)

        await api.getTournees(uniqueTourneeIds).then(function (res) {
            tourneeWithRemontee = res.data.elements
        })

        //console.log("tourneesssssss ==> ", tourneeWithRemontee);
        // Iterate over matchingElementsInGeoPassage
        for (const matchingTournee of tourneeWithRemontee) {
          const mat = _.find(state.materiels.data, {id: matchingTournee.materiel_id})
          const canto = _.find(state.cantonniers.data, {id: matchingTournee.cantonnier_id})
          materiels.push(mat)
          cantonniers.push(canto)

          for (const remontee of matchingTournee.remonteeGPSs) {
            const sec = _.find(state.reporting.secteurs, {id: remontee.secteur_id});
            if (sec) {
              secteurs.push(sec);

              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the remontee
              remontee.secteur = sec;
            }
          }
          // Adding secteur information to declarations
          for (const declaration of matchingTournee.declarations) {
            const sec = _.find(state.reporting.secteurs, {id: declaration.secteur_id});
            if (sec) {
              secteurs.push(sec);
              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the declaration
              declaration.secteur = sec;
            }
          }
          //console.log(state.materiels)
          //console.log('secteur check ===> ', secteurs)
          //console.log('arrond check ===> ', arrondissements)
        }

        console.log(state.reporting.materiels)
        console.log(state.materiels)
        console.log('materiels === >', materiels)
        console.log("tournee with remontee final please ==> ", tourneeWithRemontee)

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          let negativeVerifications = []

          for (let j = 0; j < tourneeWithRemontee[i].verifications.length; j++) {
            const verification = tourneeWithRemontee[i].verifications[j]
            if (verification.details !== 'OK' && verification.details !== 'PRESENT' &&
              verification.details !== 'PROPRE' && verification.details !== 'NOT/ACT' &&
              verification.details !== '100%') {
              negativeVerifications.push(verification)
            }
          }

          tourneeWithRemontee[i].negativeVerifications = negativeVerifications
      }

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          const {negativeVerifications, remonteeGPSs, declarations} = tourneeWithRemontee[i]

          const mergeRemonteeDeclarationVerification = [
            ...negativeVerifications,
            ...remonteeGPSs,
            ...declarations
          ]

          tourneeWithRemontee[i].mergeRemonteeDeclarationVerification = mergeRemonteeDeclarationVerification.sort((a, b) => {
            const dateA = new Date(parseInt(a.recordedAt))
            const dateB = new Date(parseInt(b.recordedAt))
            return dateA - dateB
          })
        }

        console.log(tourneeWithRemontee)
        console.log(geopassages)
        console.log('secteeeeurs wa lekher ==> ', secteurs)
        reporting = createReport(tourneeWithRemontee, secteurs, materiels, cantonniers, geopassages, photoUrl)
        console.log(reporting)
      } catch (error) {
        commit(types.REPORTING_ERROR)
        console.error(error)
      }
    }

    //if mat is the only one selected
    if (filters.daysList.length === 0 && filters.idsMateriel.length !== 0 && filters.idAgent.length === 0) {
      for (let t of tournee) {
        /*         if (filters.idsMateriel.includes('1')) {
                  console.log('theeeere')
                  matchingElementsInGeoPassage.push(t)
                } */
        if (filters.idsMateriel.includes(t.materiel_id)) {
          matchingElementsInGeoPassage.push(t)
        }
      }
      try {
        const tourneeIds = matchingElementsInGeoPassage.map(matchingTournee => matchingTournee.id)

        // Fetch unique tournee IDs
        const uniqueTourneeIds = Array.from(new Set(tourneeIds))
        console.log(uniqueTourneeIds)

        await api.getTournees(uniqueTourneeIds).then(function (res) {
            tourneeWithRemontee = res.data.elements
        })

        //console.log("tourneesssssss ==> ", tourneeWithRemontee);
        // Iterate over matchingElementsInGeoPassage
        for (const matchingTournee of tourneeWithRemontee) {
          const mat = _.find(state.materiels.data, {id: matchingTournee.materiel_id})
          const canto = _.find(state.cantonniers.data, {id: matchingTournee.cantonnier_id})
          materiels.push(mat)
          cantonniers.push(canto)

          for (const remontee of matchingTournee.remonteeGPSs) {
            const sec = _.find(state.reporting.secteurs, {id: remontee.secteur_id});
            if (sec) {
              secteurs.push(sec);

              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the remontee
              remontee.secteur = sec;
            }
          }
          // Adding secteur information to declarations
          for (const declaration of matchingTournee.declarations) {
            const sec = _.find(state.reporting.secteurs, {id: declaration.secteur_id});
            if (sec) {
              secteurs.push(sec);
              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the declaration
              declaration.secteur = sec;
            }
          }
          //console.log(state.materiels)
          //console.log('secteur check ===> ', secteurs)
          //console.log('arrond check ===> ', arrondissements)
        }

        console.log(state.reporting.materiels)
        console.log(state.materiels)
        console.log('materiels === >', materiels)
        console.log("tournee with remontee final please ==> ", tourneeWithRemontee)

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          let negativeVerifications = []

          for (let j = 0; j < tourneeWithRemontee[i].verifications.length; j++) {
            const verification = tourneeWithRemontee[i].verifications[j]
            if (verification.details !== 'OK' && verification.details !== 'PRESENT' &&
              verification.details !== 'PROPRE' && verification.details !== 'NOT/ACT' &&
              verification.details !== '100%') {
              negativeVerifications.push(verification)
            }
          }

          tourneeWithRemontee[i].negativeVerifications = negativeVerifications
      }

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          const {negativeVerifications, remonteeGPSs, declarations} = tourneeWithRemontee[i]

          const mergeRemonteeDeclarationVerification = [
            ...negativeVerifications,
            ...remonteeGPSs,
            ...declarations
          ]

          tourneeWithRemontee[i].mergeRemonteeDeclarationVerification = mergeRemonteeDeclarationVerification.sort((a, b) => {
            const dateA = new Date(parseInt(a.recordedAt))
            const dateB = new Date(parseInt(b.recordedAt))
            return dateA - dateB
          })
        }

        console.log(tourneeWithRemontee)
        console.log(geopassages)
        console.log('secteeeeurs wa lekher ==> ', secteurs)
        reporting = createReport(tourneeWithRemontee, secteurs, materiels, cantonniers, geopassages, photoUrl)
        console.log(reporting)
      } catch (error) {
        commit(types.REPORTING_ERROR)
        console.error(error)
      }
    }

    //if agent is the only one selected
    if (filters.daysList.length === 0 && filters.idsMateriel.length === 0 && filters.idAgent.length !== 0) {
      for (let t of tournee) {
        if (filters.idAgent.includes(t.cantonnier_id)) {
          matchingElementsInGeoPassage.push(t)
        }
      }
      try {
        const tourneeIds = matchingElementsInGeoPassage.map(matchingTournee => matchingTournee.id)

        // Fetch unique tournee IDs
        const uniqueTourneeIds = Array.from(new Set(tourneeIds))
        console.log(uniqueTourneeIds)

        await api.getTournees(uniqueTourneeIds).then(function (res) {
            tourneeWithRemontee = res.data.elements
        })

        //console.log("tourneesssssss ==> ", tourneeWithRemontee);
        // Iterate over matchingElementsInGeoPassage
        for (const matchingTournee of tourneeWithRemontee) {
          const mat = _.find(state.materiels.data, {id: matchingTournee.materiel_id})
          const canto = _.find(state.cantonniers.data, {id: matchingTournee.cantonnier_id})
          materiels.push(mat)
          cantonniers.push(canto)

          for (const remontee of matchingTournee.remonteeGPSs) {
            const sec = _.find(state.reporting.secteurs, {id: remontee.secteur_id});
            if (sec) {
              secteurs.push(sec);

              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the remontee
              remontee.secteur = sec;
            }
          }
          // Adding secteur information to declarations
          for (const declaration of matchingTournee.declarations) {
            const sec = _.find(state.reporting.secteurs, {id: declaration.secteur_id});
            if (sec) {
              secteurs.push(sec);
              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the declaration
              declaration.secteur = sec;
            }
          }
          //console.log(state.materiels)
          //console.log('secteur check ===> ', secteurs)
          //console.log('arrond check ===> ', arrondissements)
        }

        console.log(state.reporting.materiels)
        console.log(state.materiels)
        console.log('materiels === >', materiels)
        console.log("tournee with remontee final please ==> ", tourneeWithRemontee)

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          let negativeVerifications = []

          for (let j = 0; j < tourneeWithRemontee[i].verifications.length; j++) {
            const verification = tourneeWithRemontee[i].verifications[j]
            if (verification.details !== 'OK' && verification.details !== 'PRESENT' &&
              verification.details !== 'PROPRE' && verification.details !== 'NOT/ACT' &&
              verification.details !== '100%') {
              negativeVerifications.push(verification)
            }
          }

          tourneeWithRemontee[i].negativeVerifications = negativeVerifications
      }

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          const {negativeVerifications, remonteeGPSs, declarations} = tourneeWithRemontee[i]

          const mergeRemonteeDeclarationVerification = [
            ...negativeVerifications,
            ...remonteeGPSs,
            ...declarations
          ]

          tourneeWithRemontee[i].mergeRemonteeDeclarationVerification = mergeRemonteeDeclarationVerification.sort((a, b) => {
            const dateA = new Date(parseInt(a.recordedAt))
            const dateB = new Date(parseInt(b.recordedAt))
            return dateA - dateB
          })
        }

        console.log(tourneeWithRemontee)
        console.log(geopassages)
        console.log('secteeeeurs wa lekher ==> ', secteurs)
        reporting = createReport(tourneeWithRemontee, secteurs, materiels, cantonniers, geopassages, photoUrl)
        console.log(reporting)
      } catch (error) {
        commit(types.REPORTING_ERROR)
        console.error(error)
      }
    }

    //if mat/agent are selected
    if (filters.daysList.length === 0 && filters.idsMateriel.length !== 0 && filters.idAgent.length !== 0) {
      for (let t of tournee) {
        if (filters.idAgent.includes(t.cantonnier_id) && filters.idsMateriel.includes(t.materiel_id)) {
          matchingElementsInGeoPassage.push(t)
        }
      }
      try {
        const tourneeIds = matchingElementsInGeoPassage.map(matchingTournee => matchingTournee.id)

        // Fetch unique tournee IDs
        const uniqueTourneeIds = Array.from(new Set(tourneeIds))
        console.log(uniqueTourneeIds)

        await api.getTournees(uniqueTourneeIds).then(function (res) {
            tourneeWithRemontee = res.data.elements
        })

        //console.log("tourneesssssss ==> ", tourneeWithRemontee);
        // Iterate over matchingElementsInGeoPassage
        for (const matchingTournee of tourneeWithRemontee) {
          const mat = _.find(state.materiels.data, {id: matchingTournee.materiel_id})
          const canto = _.find(state.cantonniers.data, {id: matchingTournee.cantonnier_id})
          materiels.push(mat)
          cantonniers.push(canto)

          for (const remontee of matchingTournee.remonteeGPSs) {
            const sec = _.find(state.reporting.secteurs, {id: remontee.secteur_id});
            if (sec) {
              secteurs.push(sec);

              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the remontee
              remontee.secteur = sec;
            }
          }
          // Adding secteur information to declarations
          for (const declaration of matchingTournee.declarations) {
            const sec = _.find(state.reporting.secteurs, {id: declaration.secteur_id});
            if (sec) {
              secteurs.push(sec);
              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the declaration
              declaration.secteur = sec;
            }
          }
          //console.log(state.materiels)
          //console.log('secteur check ===> ', secteurs)
          //console.log('arrond check ===> ', arrondissements)
        }

        console.log(state.reporting.materiels)
        console.log(state.materiels)
        console.log('materiels === >', materiels)
        console.log("tournee with remontee final please ==> ", tourneeWithRemontee)

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          let negativeVerifications = []

          for (let j = 0; j < tourneeWithRemontee[i].verifications.length; j++) {
            const verification = tourneeWithRemontee[i].verifications[j]
            if (verification.details !== 'OK' && verification.details !== 'PRESENT' &&
              verification.details !== 'PROPRE' && verification.details !== 'NOT/ACT' &&
              verification.details !== '100%') {
              negativeVerifications.push(verification)
            }
          }

          tourneeWithRemontee[i].negativeVerifications = negativeVerifications
      }

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          const {negativeVerifications, remonteeGPSs, declarations} = tourneeWithRemontee[i]

          const mergeRemonteeDeclarationVerification = [
            ...negativeVerifications,
            ...remonteeGPSs,
            ...declarations
          ]

          tourneeWithRemontee[i].mergeRemonteeDeclarationVerification = mergeRemonteeDeclarationVerification.sort((a, b) => {
            const dateA = new Date(parseInt(a.recordedAt))
            const dateB = new Date(parseInt(b.recordedAt))
            return dateA - dateB
          })
        }

        console.log(tourneeWithRemontee)
        console.log(geopassages)
        console.log('secteeeeurs wa lekher ==> ', secteurs)
        reporting = createReport(tourneeWithRemontee, secteurs, materiels, cantonniers, geopassages, photoUrl)
        console.log(reporting)
      } catch (error) {
        commit(types.REPORTING_ERROR)
        console.error(error)
      }
    }

    //if date/agent are selected
    if (filters.daysList.length !== 0 && filters.idsMateriel.length === 0 && filters.idAgent.length !== 0) {
      console.log('date and agent is the only one selected')
      for (let t of tournee) {
        for (let d of filters.daysList) {
          if (d.length === 4) {
            if (d === t.day.substring(0, 4) && filters.idAgent.includes(t.cantonniers_id)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
          if (d.length === 7) {
            if (d === t.day.substring(0, 7) && filters.idAgent.includes(t.cantonniers_id)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
          if (d.length === 10) {
            if (d === t.day && filters.idAgent.includes(t.cantonniers_id)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
        }
      }
      try {
        const tourneeIds = matchingElementsInGeoPassage.map(matchingTournee => matchingTournee.id)

        // Fetch unique tournee IDs
        const uniqueTourneeIds = Array.from(new Set(tourneeIds))
        console.log(uniqueTourneeIds)

        await api.getTournees(uniqueTourneeIds).then(function (res) {
            tourneeWithRemontee = res.data.elements
        })

        //console.log("tourneesssssss ==> ", tourneeWithRemontee);
        // Iterate over matchingElementsInGeoPassage
        for (const matchingTournee of tourneeWithRemontee) {
          const mat = _.find(state.materiels.data, {id: matchingTournee.materiel_id})
          const canto = _.find(state.cantonniers.data, {id: matchingTournee.cantonnier_id})
          materiels.push(mat)
          cantonniers.push(canto)

          for (const remontee of matchingTournee.remonteeGPSs) {
            const sec = _.find(state.reporting.secteurs, {id: remontee.secteur_id});
            if (sec) {
              secteurs.push(sec);

              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the remontee
              remontee.secteur = sec;
            }
          }
          // Adding secteur information to declarations
          for (const declaration of matchingTournee.declarations) {
            const sec = _.find(state.reporting.secteurs, {id: declaration.secteur_id});
            if (sec) {
              secteurs.push(sec);
              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the declaration
              declaration.secteur = sec;
            }
          }
          //console.log(state.materiels)
          //console.log('secteur check ===> ', secteurs)
          //console.log('arrond check ===> ', arrondissements)
        }

        console.log(state.reporting.materiels)
        console.log(state.materiels)
        console.log('materiels === >', materiels)
        console.log("tournee with remontee final please ==> ", tourneeWithRemontee)

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          let negativeVerifications = []

          for (let j = 0; j < tourneeWithRemontee[i].verifications.length; j++) {
            const verification = tourneeWithRemontee[i].verifications[j]
            if (verification.details !== 'OK' && verification.details !== 'PRESENT' &&
              verification.details !== 'PROPRE' && verification.details !== 'NOT/ACT' &&
              verification.details !== '100%') {
              negativeVerifications.push(verification)
            }
          }

          tourneeWithRemontee[i].negativeVerifications = negativeVerifications
      }

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          const {negativeVerifications, remonteeGPSs, declarations} = tourneeWithRemontee[i]

          const mergeRemonteeDeclarationVerification = [
            ...negativeVerifications,
            ...remonteeGPSs,
            ...declarations
          ]

          tourneeWithRemontee[i].mergeRemonteeDeclarationVerification = mergeRemonteeDeclarationVerification.sort((a, b) => {
            const dateA = new Date(parseInt(a.recordedAt))
            const dateB = new Date(parseInt(b.recordedAt))
            return dateA - dateB
          })
        }

        console.log(tourneeWithRemontee)
        console.log(geopassages)
        console.log('secteeeeurs wa lekher ==> ', secteurs)
        reporting = createReport(tourneeWithRemontee, secteurs, materiels, cantonniers, geopassages, photoUrl)
        console.log(reporting)
      } catch (error) {
        commit(types.REPORTING_ERROR)
        console.error(error)
      }
    }

    //if date/mat are selected
    if (filters.daysList.length !== 0 && filters.idsMateriel.length !== 0 && filters.idAgent.length === 0) {
      console.log('date and agent is the only one selected')
      for (let t of tournee) {
        for (let d of filters.daysList) {
          if (d.length === 4) {
            if (d === t.day.substring(0, 4) && filters.idsMateriel.includes(t.materiel_id)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
          if (d.length === 7) {
            if (d === t.day.substring(0, 7) && filters.idsMateriel.includes(t.materiel_id)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
          if (d.length === 10) {
            if (d === t.day && filters.idsMateriel.includes(t.materiel_id)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
        }
      }
      try {
        const tourneeIds = matchingElementsInGeoPassage.map(matchingTournee => matchingTournee.id)

        // Fetch unique tournee IDs
        const uniqueTourneeIds = Array.from(new Set(tourneeIds))
        console.log(uniqueTourneeIds)

        await api.getTournees(uniqueTourneeIds).then(function (res) {
            tourneeWithRemontee = res.data.elements
        })

        //console.log("tourneesssssss ==> ", tourneeWithRemontee);
        // Iterate over matchingElementsInGeoPassage
        for (const matchingTournee of tourneeWithRemontee) {
          const mat = _.find(state.materiels.data, {id: matchingTournee.materiel_id})
          const canto = _.find(state.cantonniers.data, {id: matchingTournee.cantonnier_id})
          materiels.push(mat)
          cantonniers.push(canto)

          for (const remontee of matchingTournee.remonteeGPSs) {
            const sec = _.find(state.reporting.secteurs, {id: remontee.secteur_id});
            if (sec) {
              secteurs.push(sec);

              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the remontee
              remontee.secteur = sec;
            }
          }
          // Adding secteur information to declarations
          for (const declaration of matchingTournee.declarations) {
            const sec = _.find(state.reporting.secteurs, {id: declaration.secteur_id});
            if (sec) {
              secteurs.push(sec);
              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the declaration
              declaration.secteur = sec;
            }
          }
          //console.log(state.materiels)
          //console.log('secteur check ===> ', secteurs)
          //console.log('arrond check ===> ', arrondissements)
        }

        console.log(state.reporting.materiels)
        console.log(state.materiels)
        console.log('materiels === >', materiels)
        console.log("tournee with remontee final please ==> ", tourneeWithRemontee)

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          let negativeVerifications = []

          for (let j = 0; j < tourneeWithRemontee[i].verifications.length; j++) {
            const verification = tourneeWithRemontee[i].verifications[j]
            if (verification.details !== 'OK' && verification.details !== 'PRESENT' &&
              verification.details !== 'PROPRE' && verification.details !== 'NOT/ACT' &&
              verification.details !== '100%') {
              negativeVerifications.push(verification)
            }
          }

          tourneeWithRemontee[i].negativeVerifications = negativeVerifications
      }

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          const {negativeVerifications, remonteeGPSs, declarations} = tourneeWithRemontee[i]

          const mergeRemonteeDeclarationVerification = [
            ...negativeVerifications,
            ...remonteeGPSs,
            ...declarations
          ]

          tourneeWithRemontee[i].mergeRemonteeDeclarationVerification = mergeRemonteeDeclarationVerification.sort((a, b) => {
            const dateA = new Date(parseInt(a.recordedAt))
            const dateB = new Date(parseInt(b.recordedAt))
            return dateA - dateB
          })
        }

        console.log(tourneeWithRemontee)
        console.log(geopassages)
        console.log('secteeeeurs wa lekher ==> ', secteurs)
        reporting = createReport(tourneeWithRemontee, secteurs, materiels, cantonniers, geopassages, photoUrl)
        console.log(reporting)
      } catch (error) {
        commit(types.REPORTING_ERROR)
        console.error(error)
      }
    }

    //if all filters are selected or date/mat are selected
    if ((filters.daysList.length !== 0 && filters.idsMateriel.length !== 0 && filters.idAgent.length !== 0)) {
      console.log('all filters are selected or materiels and date are selected')
      //if Tous is selected in materiels
      for (let t of tournee) {
        for (let d of filters.daysList) {
          if (d.length === 4) {
            if (d === t.day.substring(0, 4) && filters.idsMateriel.includes(t.materiel_id) && filters.idAgent.includes(t.cantonnier_id)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
          if (d.length === 7) {
            if (d === t.day.substring(0, 7) && filters.idsMateriel.includes(t.materiel_id) && filters.idAgent.includes(t.cantonnier_id)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
          if (d.length === 10) {
            if (d === t.day && filters.idsMateriel.includes(t.materiel_id) && filters.idAgent.includes(t.cantonnier_id)) {
              matchingElementsInGeoPassage.push(t)
            }
          }
        }

      }

      try {
        const tourneeIds = matchingElementsInGeoPassage.map(matchingTournee => matchingTournee.id)

        // Fetch unique tournee IDs
        const uniqueTourneeIds = Array.from(new Set(tourneeIds))
        console.log(uniqueTourneeIds)

        await api.getTournees(uniqueTourneeIds).then(function (res) {
            tourneeWithRemontee = res.data.elements
        })

        //console.log("tourneesssssss ==> ", tourneeWithRemontee);
        // Iterate over matchingElementsInGeoPassage
        for (const matchingTournee of tourneeWithRemontee) {
          const mat = _.find(state.materiels.data, {id: matchingTournee.materiel_id})
          const canto = _.find(state.cantonniers.data, {id: matchingTournee.cantonnier_id})
          materiels.push(mat)
          cantonniers.push(canto)

          for (const remontee of matchingTournee.remonteeGPSs) {
            const sec = _.find(state.reporting.secteurs, {id: remontee.secteur_id});
            if (sec) {
              secteurs.push(sec);

              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the remontee
              remontee.secteur = sec;
            }
          }
          // Adding secteur information to declarations
          for (const declaration of matchingTournee.declarations) {
            const sec = _.find(state.reporting.secteurs, {id: declaration.secteur_id});
            if (sec) {
              secteurs.push(sec);
              const matchingArrondissement = arrondissements.find(arr => arr.id === sec.arrondissement_id);

              // If a match is found, add the arrondissement's name to the secteur
              if (matchingArrondissement) {
                sec.arrondissement_nom = matchingArrondissement.nom;
              }

              // Add sector information to the declaration
              declaration.secteur = sec;
            }
          }
          //console.log(state.materiels)
          //console.log('secteur check ===> ', secteurs)
          //console.log('arrond check ===> ', arrondissements)
        }

        console.log(state.reporting.materiels)
        console.log(state.materiels)
        console.log('materiels === >', materiels)
        console.log("tournee with remontee final please ==> ", tourneeWithRemontee)

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          let negativeVerifications = []

          for (let j = 0; j < tourneeWithRemontee[i].verifications.length; j++) {
            const verification = tourneeWithRemontee[i].verifications[j]
            if (verification.details !== 'OK' && verification.details !== 'PRESENT' &&
              verification.details !== 'PROPRE' && verification.details !== 'NOT/ACT' &&
              verification.details !== '100%') {
              negativeVerifications.push(verification)
            }
          }

          tourneeWithRemontee[i].negativeVerifications = negativeVerifications
      }

        for (let i = 0; i < tourneeWithRemontee.length; i++) {
          const {negativeVerifications, remonteeGPSs, declarations} = tourneeWithRemontee[i]

          const mergeRemonteeDeclarationVerification = [
            ...negativeVerifications,
            ...remonteeGPSs,
            ...declarations
          ]

          tourneeWithRemontee[i].mergeRemonteeDeclarationVerification = mergeRemonteeDeclarationVerification.sort((a, b) => {
            const dateA = new Date(parseInt(a.recordedAt))
            const dateB = new Date(parseInt(b.recordedAt))
            return dateA - dateB
          })
        }

        console.log(tourneeWithRemontee)
        console.log(geopassages)
        console.log('secteeeeurs wa lekher ==> ', secteurs)
        reporting = createReport(tourneeWithRemontee, secteurs, materiels, cantonniers, geopassages, photoUrl)
        console.log(reporting)
      } catch (error) {
        commit(types.REPORTING_ERROR)
        console.error(error)
      }
    }

    if (reporting.length !== 0) {
      console.log(reporting)
      console.log('we hereeee')
      CsvExport.forgeCsvReporting(reporting)
      commit(types.REPORTING_FETCHED)
    } else {
      console.log(reporting)
      console.log('weee heree')
      commit(types.REPORTING_EMPTY)
    }
  },
}

function createReport (tourneeWithRemontee, secteurs, materiels, cantonniers, geopassages, photoUrl) {
  console.log(photoUrl)
  const reporting = []

  console.log('tourneeWithRemontee ==> ', tourneeWithRemontee  )
  for (let i = 0; i < tourneeWithRemontee.length; i++) {
    console.log(materiels)
    const staticLine = {
      'createdAt': moment(tourneeWithRemontee[i].startedAt).tz('Europe/Paris', true).format('HH:mm:ss'),
      'secteur': {
        'arrondissement': secteurs[i].arrondissement_nom,
        'nom': secteurs[i] ? secteurs[i].nom : 'error'
      },
      'materiel': {
        'arrondissement': secteurs[i].arrondissement_nom,
        'numero': materiels[i] ? materiels[i].nom : 'error',
        'type': materiels[i] ? materiels[i].materielType : 'error'
      },
      'cantonnier': {
        'arrondissement': secteurs[i].arrondissement_nom,
        'nom': cantonniers[i] ? cantonniers[i].nom.trim() : 'error',
        'prenom': cantonniers[i] ? cantonniers[i].prenom.trim() : 'error'
      },
      'numeroVoie': '-',
      'voie': '-',
      'recorded_at': '',
      'provider': 'gps',
      'genre': 'VERIFS AVANT DEPART',
      'anomalieDetail': 'CANTONNIER',
      'anomalieDetail2': cantonniers[i] ? (cantonniers[i].nom + cantonniers[i].prenom).trim() : 'error',
      'commentaire': '-',
      'accuracy': 8,
      'day': tourneeWithRemontee[i].day,
      'ville_id': tourneeWithRemontee[i].ville_id,
      'coords': {
        'lat': '-',
        'lon': '-',
      },
      'photo1': '-',
      'photo2': '-',
      'photo3': '-',
      'photo4': '-',
      'photo5': '-',
      'QrCode': '-',
      'tag_NFC': '',
    }

    reporting.push(staticLine)

    for (let j = 0; j < tourneeWithRemontee[i].mergeRemonteeDeclarationVerification.length; j++) {
      const timestamp = tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].recordedAt
      if (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].recordedAt) {
        const formattedTime = moment(parseInt(timestamp, 10)).tz('Europe/Paris', true).format('HH:mm:ss')
        tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].formattedTime = formattedTime
      }

      let allGeo = {
        'createdAt': tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].recordedAt ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].formattedTime : moment(tourneeWithRemontee[i].startedAt).tz('Europe/Paris', true).format('HH:mm:ss'),
        'secteur': {
          'arrondissement': tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].secteur ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].secteur.arrondissement_nom : '-',
          'nom': tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].secteur ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].secteur.nom : '-'
        },
        'materiel': {
          'arrondissement': tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].secteur ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].secteur.arrondissement_nom : '-',
          'numero': materiels[i] ? materiels[i].nom : 'error',
          'type': materiels[i] ? materiels[i].materielType : 'error'
        },
        'cantonnier': {
          'arrondissement': tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].secteur ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].secteur.arrondissement_nom : '',
          'nom': cantonniers[i] ? cantonniers[i].nom.trim() : 'error',
          'prenom': cantonniers[i] ? cantonniers[i].prenom.trim() : 'error'
        },
        'numeroVoie': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j] && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].num_rue) ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].num_rue : '-',
        'voie': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j] && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nom_rue) ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nom_rue : '-',
        'recorded_at': '',
        'provider': 'gps',
        'genre': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].outil !== undefined) ? 'VERIFS AVANT DEPART' :
          tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].typeRemonteeGPS ?
            tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].typeRemonteeGPS :
            tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nature + ' : ' +
            tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].type,
        'anomalieDetail': tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].outil !== undefined ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].outil : '-',
        'anomalieDetail2': tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].details !== undefined ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].details.trim() : '-',
        'commentaire': tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].commentaire ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].commentaire : '-',
        'accuracy': 8,
        'day': tourneeWithRemontee[i].day,
        'ville_id': tourneeWithRemontee[i].ville_id,
        'coords': {
          'lat': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].typeRemonteeGPS !== undefined
            || tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nature !== undefined ) ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].lat + 'N ' : '',
          'lon': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].typeRemonteeGPS !== undefined
            || tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nature !== undefined) ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].lon + 'E' : '',
        },
        'photo1': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nature !== undefined
          && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos !== undefined
          && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos[0] !== undefined) ? (photoUrl + tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos[0].id) : '-',
        'photo2': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nature !== undefined
          && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos !== undefined
          && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos[1] !== undefined) ? (photoUrl + tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos[1].id) : '-',
        'photo3': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nature !== undefined
          && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos !== undefined
          && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos[2] !== undefined) ? (photoUrl + tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos[2].id) : '-',
        'photo4': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nature !== undefined
          && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos !== undefined
          && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos[3] !== undefined) ? (photoUrl + tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos[3].id) : '-',
        'photo5': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nature !== undefined
          && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos !== undefined
          && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos[4] !== undefined) ? (photoUrl + tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].photos[4].id) : '-',
        'QrCode': (tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nature !== undefined && tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nature !== 'DEPOT_SAC') ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].qrCode : '-',
        'tag_NFC': tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nfc ? tourneeWithRemontee[i].mergeRemonteeDeclarationVerification[j].nfc : '-',
      }

      reporting.push(allGeo)
    }
  }

  return reporting
}

function getLocaleMessageFromSpacedogCredentialsError (err) {
  let raison
  switch (err.error.code) {
    case 'invalid-credentials':
      raison = 'Nom d\'utilisateur ou mot de passe incorrect'
      break
    case 'disabled-credentials':
      raison = 'Compte désactivé'
      break
    case 'expired-access-token':
      raison = 'Session expirée'
      api.logout()
      break
    default:
      raison = 'Inconnue'
  }
  return `Impossible de vous identifier (raison : ${raison})`
}

function addCityAttributeIfNecessary (spacedogObject, currentUser) {
  if (currentUser.villeId === 1) {
    return spacedogObject
  } else {
    spacedogObject.ville_id = currentUser.villeId
    return spacedogObject
  }
}

function getArrondissementLabel (arrs, key) {
  var arr = _.find(arrs, function (item) {
    if (key === item.id) {
      return item.value
    }
  })
  return arr.value
}

const getFormattedDate = () => {
  const today = new Date()
  const year = today.getFullYear().toString()
  let month = (today.getMonth() + 1).toString()
  let day = today.getDate().toString()

  // Add leading zeros if necessary
  if (month.length === 1) {
    month = '0' + month
  }
  if (day.length === 1) {
    day = '0' + day
  }

  const formattedDate = `${year}-${month}-${day}`
  return formattedDate
}

const removeFromArray = (arr, elem) => {
  const idx = arr.indexOf(elem)
  if (idx !== -1) arr.splice(idx, 1)
}



// WEBPACK FOOTER //
// ./src/store/actions.js